import { render } from "./App.vue?vue&type=template&id=43f8a59e"
const script = {}
script.render = render

export default script